var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"value":_vm.date == 'Caducado' ? 0 : _vm.setProgress(_vm.date),"height":"25","color":_vm.date == 'Caducado' ? _vm.red :_vm.setColor(_vm.date)}},[_c('small',[_c('strong',[_vm._v(" "+_vm._s(_vm.date == 'Caducado' ? _vm.date : _vm.setValue(_vm.date))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }